import { Breakpoints, styled } from '@volkswagen-onehub/components-core';

export const DiscardChangesCTAContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;

  @media (min-width: ${Breakpoints.b560}px) {
    flex-direction: row;
  }
`;
